module.exports = __webpack_public_path__ + "static/img/12areaA_02.08e0979.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/12areaA_02.png
// module id = 884
// module chunks = 1